export interface IWhatToDoItem {
  id: number
  icon: WhatToDoIcon
  subject: string
  content: string
}

export enum WhatToDoIcon {
  Damage = 'damage',
  Diseased = 'diseased',
  Legal = 'legal',
  Loss = 'loss',
  DamageRepair = 'damage-repair'
}

export const getWhatToDoItemIconName = (wtdItem: IWhatToDoItem) => {
  switch (wtdItem.icon) {
  case WhatToDoIcon.Damage:
    return 'fragile'
  case WhatToDoIcon.DamageRepair:
    return 'mask'
  case WhatToDoIcon.Diseased:
    return 'cross'
  case WhatToDoIcon.Loss:
    return 'ghost'
  case WhatToDoIcon.Legal:
    return 'legal'
  default:
    return 'question'
  }
}
